export default __webpack_public_path__ + "static/media/slide7.8a084f78.jpg";